<template>
  <div class="registered-dom">
    <NavHeaderBar title="大会注册" :onClickRight="onClickRight" rightArrow />
    <div class="notice-bar">
      <div class="title">注册说明</div>
      <div class="item" v-html="dataSource.registeExplain"></div>
    </div>
    <div class="reginstered-content">
      <reg-list v-for="(item, index) in dataSource.registeItem" :key="index" :img="item.picUrl" :title="item.title"
        :amount="item.amount" :time="item.endTime" :itemExplain="item.itemExplain" :id="item.id"
        :regJumpUrl="item.regJumpUrl" />
    </div>
  </div>
</template>

<script>
import { queryRegistered } from "@/config/conference";
import RegList from "./components/RegList.vue";
import { getEnv } from "@/config/utils";
import share from "@/mixins/share";
import { Dialog } from "vant";
export default {
  name: "registered",
  mixins: [share],
  components: { RegList },
  data: function () {
    return {
      dataSource: {
        registeExplain: "",
        registeItem: [],
        share: "",
        sharedesc: "",
        shareimg: "",
        tips: "",
        titleColourCode: ""
      }
    };
  },
  mounted: function () {
    this.init();
  },
  methods: {
    init() {
      queryRegistered(this.$route.query.code).then(result => {
        const { data, success } = result;
        if (success === "ok") {
          if (getEnv() !== "h5") {
            let shars = {};
            shars.shareId = this.$route.query.shareId || "0";
            shars.bizId = this.$route.query.bizId || data.id;
            const { cover, sharedesc, share, id } = data;
            const shareimg = data.shareimg || cover;
            const bizType = "5";
            const url =
              window.location.href.split("?")[0] +
              "?code=" +
              this.$route.query.code +
              "&isConference=" +
              this.$route.query.isConference;
            this.share(bizType, url, shars, shareimg, sharedesc, share, id);
          }
          document.title = result.data.projectTitle || "药大咖";
          if (data.signStatus == 1) {
            Dialog.alert({
              title: "温馨提示",
              message: "您已经报过名了，点击确定返回会议首页"
            }).then(() => {
              this.$router.push({
                path: "/conference",
                query: { code: this.$route.query.code }
              });
            });
          }

          if (data.registerType == 2) {
            this.$router.push({
              path: "/conference/register",
              query: { code: this.$route.query.code }
            });
          }


          this.dataSource = result.data;
          this.dataSource.registeExplain = result.data.registeExplain.replace(
            /(\r\n|\n|\r)/gm,
            "<br />"
          );
          console.info(result.data.registeExplain);
        }
      });
    },

    onClickRight() {
      this.$router.push({
        path: "/conference",
        query: { code: this.$route.query.code }
      });
    }
  }
};
</script>
<style>
.registered-dom .notice-bar {
  color: #ed6a0c;
  font-size: 14px;
  line-height: 24px;
  background-color: #fffbe8;
  padding: 15px;
  margin-bottom: 10px;
  margin-top: 48px;
}

.notice-bar .title {
  font-size: 16px;
  font-weight: 800;
  padding-bottom: 5px;
}
</style>
